import {
  Box,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import {
  createMicro3Request,
  deleteMicro3Request,
} from '../../../redux/microbiologyRedux';
import {
  getReportsPZ04,
  loadReportPZ04ByIdRequest,
} from '../../../redux/reportsPZ04Redux';

const Micro_2 = ({ props }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state) => getUser(state));
  const [hour, setHour] = useState('');
  const [cultureYeast, setCultureYeast] = useState('');
  const [wildYeast, setWildYeast] = useState('');
  const [aerobicBacteria, setAerobicBacteria] = useState('');
  const [beerSpoilageBacteria, setBeerSpoilageBacteria] = useState('');
  const [ezFluo, setEzFluo] = useState('');
  const [other, setOther] = useState('');

  const [dateAnalysis, setDateAnalysis] = useState(
    props.micro_3 ? props.micro_3 : [],
  );
  const [reloadReport, setReloadReport] = useState(0);
  let lp = 1;

  useEffect(() => {
    const start = async () => {
      const res = await dispatch(loadReportPZ04ByIdRequest(props.id));
      if (res) {
        setDateAnalysis(res.data.micro_3 ? res.data.micro_3 : []);
      }
    };
    start();
  }, [dispatch, props.id, reloadReport]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data_micro_2 = {
      reportPZ04Id: props.id,
      userId: user.users.id,
      hour,
      cultureYeast,
      wildYeast,
      aerobicBacteria,
      beerSpoilageBacteria,
      ezFluo,
      other,
    };
    setDateAnalysis((prev) => [...prev, data_micro_2]);
    const res = await dispatch(createMicro3Request(data_micro_2));
    if (res.status === 201) {
      setReloadReport((prev) => prev + 1);
      console.log('Dodano mikrobiologię 3', res);
    } else {
      console.log('Błąd dodania mikrobiologii 3', res);
    }
  };
  const handleRemove = async (id) => {
    const res = await dispatch(deleteMicro3Request(id));
    if (res.status === 200) {
      setDateAnalysis((prev) => prev.filter((item) => item.id !== id));
      console.log('Usunięto mikrobiologię 3', res);
    } else {
      console.log('Błąd usunięcia mikrobiologii 3', res);
    }
  };
  return (
    <Box
      sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}
      component={'form'}
      onSubmit={handleSubmit}
    >
      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.stage_3.resultsOfAnalysis')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      <Box sx={{ mb: 2 }}>
        <TextField
          sx={{ width: '25%', mr: 2 }}
          label={t('rnModule.stage_1.orderNumber')}
          variant="outlined"
          value={props.orderNumber}
          disabled
        />
        <TextField
          sx={{ width: '45%', mr: 2 }}
          label={t('rnModule.stage_1.brand')}
          variant="outlined"
          value={props.orderProduct.description}
          disabled
        />
        <TextField
          sx={{ width: '25%', mr: 2 }}
          label={t('rnModule.stage_3.identificationFinishGoods')}
          variant="outlined"
          value={`${dayjs(props.expirityDate).format('DD.MM.YYYY')} ${
            props.orderBatch
          }`}
          disabled
        />
      </Box>
      <Box>
        <TextField
          sx={{ width: '10%', mr: 1 }}
          label={t('rnModule.stage_3.hour')}
          variant="outlined"
          value={hour}
          onChange={(e) => setHour(e.target.value)}
        />
        <TextField
          sx={{ width: '15%', mr: 1 }}
          label={t('rnModule.stage_1.cultureYeast')}
          variant="outlined"
          value={cultureYeast}
          onChange={(e) => setCultureYeast(e.target.value)}
        />
        <TextField
          sx={{ width: '15%', mr: 1 }}
          label={t('rnModule.stage_1.wildYeast')}
          variant="outlined"
          value={wildYeast}
          onChange={(e) => setWildYeast(e.target.value)}
        />
        <TextField
          sx={{ width: '15%', mr: 1 }}
          label={t('rnModule.stage_1.aerobicBacteria')}
          variant="outlined"
          value={aerobicBacteria}
          onChange={(e) => setAerobicBacteria(e.target.value)}
        />
        <TextField
          sx={{ width: '15%', mr: 1 }}
          label={t('rnModule.stage_1.beerSpoilageBacteria')}
          variant="outlined"
          value={beerSpoilageBacteria}
          onChange={(e) => setBeerSpoilageBacteria(e.target.value)}
        />
        <TextField
          sx={{ width: '15%', mr: 1 }}
          label={t('rnModule.stage_3.ezFluo')}
          variant="outlined"
          value={ezFluo}
          onChange={(e) => setEzFluo(e.target.value)}
        />
        <TextField
          sx={{ width: '10%', mr: 1 }}
          label={t('rnModule.stage_1.other')}
          variant="outlined"
          value={other}
          onChange={(e) => setOther(e.target.value)}
        />
      </Box>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{ mt: 2, mb: 2 }}
      >
        {t('rnModule.stage_1.submitMicro_1')}
      </Button>
      <TableContainer sx={{ mb: 2 }}>
        <Table sx={{ mb: 2 }}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Lp</TableCell>
              <TableCell>{t('rnModule.stage_1.orderNumber')}</TableCell>
              <TableCell>{t('rnModule.stage_1.brand')}</TableCell>
              <TableCell>
                {t('rnModule.stage_3.identificationFinishGoods')}
              </TableCell>
              <TableCell>{t('rnModule.stage_3.hour')}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {t('rnModule.stage_1.cultureYeast')}
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {t('rnModule.stage_1.wildYeast')}
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {t('rnModule.stage_1.aerobicBacteria')}
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {t('rnModule.stage_1.beerSpoilageBacteria')}
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>Ez-Fluo</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {t('rnModule.stage_1.other_micro_1')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dateAnalysis.map((micro) => (
              <TableRow
                hover
                key={micro.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>
                  <Button
                    sx={{ color: 'red', p: '0' }}
                    onClick={() => handleRemove(micro.id)} // TODO:
                    // zaimplementować funkcję usuwania
                  >
                    <DeleteIcon />
                  </Button>
                </TableCell>
                <TableCell>{lp++}</TableCell>
                <TableCell>{props.orderNumber}</TableCell>
                <TableCell>{props.orderProduct.description}</TableCell>
                <TableCell>
                  {`${dayjs(props.expirityDate).format('DD.MM.YYYY')} ${
                    props.orderBatch
                  }`}
                </TableCell>
                <TableCell>{micro.hour}</TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  {micro.cultureYeast}
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  {micro.wildYeast}
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  {micro.aerobicBacteria}
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  {micro.beerSpoilageBacteria}
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  {micro.ezFluo}
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  {micro.other}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        type="submit"
        sx={{
          color: 'white',
          bgcolor: '#C09A53',
          ':hover': { bgcolor: '#9c7c43' },
          height: '40px',
          width: '150px',
          mt: 2,
          mb: 50,
        }}
      >
        {t('rnModule.stage_1.confirmationFirstStep')}
      </Button>
    </Box>
  );
};

export default Micro_2;
